module.exports = __webpack_public_path__ + "img/Real_Estate_Metaverse.3092245e.png";